
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 100,
      filter: JSON.stringify([new Filter("companyId", +this.$route.params.id)]),
    },
    className: "ClinicBranch",
  });

  clinicObjectDataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "clinic",
  });
  loaded: boolean = false;

  createItemModel: any = {
    companyId: +this.$route.params.id,
    caption: "",
  };

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Компании",
        to: "/manage/clinics/",
        exact: true,
      },
      {
        text: this.clinicObjectDataSource.model?.caption,
        to: `/manage/clinics/${+this.$route.params.id}`,
        exact: true,
      },
      {
        text: "Филиалы",
        to: `/manage/clinics/${+this.$route.params.id}/branches`,
        exact: true,
      },
    ];
  }

  created() {
    this.clinicObjectDataSource.get();
  }
}
